import i18n from '~/i18n';
import Stores from '~/stores/Stores';
import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

class FavoriteFolderForm extends Form {
  stores: Stores;
  initialValue = '';

  constructor(data, options, stores) {
    super(data, options);
    this.initialValue = data.values.title;
    this.stores = stores;
  }

  options() {
    return {
      validateOnInit: false,
      validateOnChange: true,
      validateOnBlur: false,
    };
  }

  /*
    Below we are returning a `plugins` object using the `validatorjs` package
    to enable `DVR` functionalities (Declarative Validation Rules).
  */
  plugins() {
    return {
      dvr: dvr({
        package: validatorjs,
        extend: ({ validator }) => {
          const messages = validator.getMessages('en');
          messages['required.title'] = i18n.t('form.rule.title.required', '제목을 입력해 주세요.');
          messages.max = i18n.t('form.rule.max', ':max자 이하로 입력해 주세요.');
          validator.register(
            'checkFolderTitle',
            (value) => {
              return value === this.initialValue || !this.stores.favoritesStore.isExistTitle(value);
            },
            i18n.t('addFolderModal.sameTitle', '동일한 폴더 이름이 존재합니다.')
          );
          validator.setMessages('en', messages);
        },
      }),
    };
  }

  /*
    Return the `fields` as a collection into the `setup()` method
    with a `rules` property for the validation.
  */
  setup() {
    return {
      fields: [
        {
          name: 'title',
          rules: 'required|max:30|checkFolderTitle',
          value: '',
        },
      ],
    };
  }
}

export default FavoriteFolderForm;
